var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScrewdriver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0938 6.58258L8.96532 7.58572L10.0938 8.71424L2.94651 15.8616L1.44181 16.3631L0.0624997 19.1218L0.940242 19.9995L3.82426 18.7456L4.45121 17.2409L11.4732 10.0936L12.6017 11.2221L13.6048 10.0936C13.6048 10.0936 12.6017 9.3412 13.7302 8.21268C14.3572 7.58572 15.3603 8.33807 17.2412 6.45719L19.8744 3.82396C19.8744 3.82396 20.6268 2.57004 19.1221 1.06534C17.6174 -0.43936 16.3634 0.312991 16.3634 0.312991L13.7302 2.94622C11.9747 4.70171 12.6017 5.83023 12.1001 6.3318C10.9716 7.46033 10.0938 6.58258 10.0938 6.58258ZM13.981 7.08415L13.1033 6.20641L17.8681 1.44152L18.7459 2.31926L13.981 7.08415Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrewdriver);
export default __webpack_public_path__ + "static/media/Screwdriver.396218a00302b81e5a821f945ddd6a5b.svg";
export { ForwardRef as ReactComponent };